import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { ProductionValidationResponse } from '../models/production-validation-response.model';
import { ProductionValidator } from '../models/production-validation-view.model';

@Injectable({
  providedIn: 'root'
})
export class ProductionValidationService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  runValidationCheck(productionJobId: string, validator: ProductionValidator): Observable<ProductionValidationResponse> {
    return this.http.get<ProductionValidationResponse>(`${this.appConfigService.getConfig().webApi}/api2/ProductionJob/${productionJobId}/Validation/${validator}`)
      .pipe(catchError(this.errorHandler.handleError<ProductionValidationResponse>(`validate ProductionJobId: ${productionJobId}, Validation: ${validator}`)));
  }

  updateActions(productionJobId: string, validator: ProductionValidator): Observable<ProductionValidationResponse> {
    return this.http.get<ProductionValidationResponse>(`${this.appConfigService.getConfig().webApi}/api2/ProductionJob/${productionJobId}/Validation/${validator}/Actions`)
      .pipe(catchError(this.errorHandler.handleError<ProductionValidationResponse>(`validation actions ProductionJobId: ${productionJobId}, Validation: ${validator}`)));
  }
}
